import Faq from './Faq.page';

export default Faq;